export default "__VITE_ASSET__BnM4Kknl__"